<template>
  <b-modal v-model="modal" :title="title" size="lg" :hide-footer="true">
    <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
    </loading>
    <div class="row">
      <div class="col-lg-12">
        <b-tabs justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
          <b-tab active>
            <template v-slot:title>
              <span class="">Aguardando ({{ totalWaiting }})</span>
            </template>
            <list-waiting @loadWaitList="loadWaitList($event)" :filters="filter"/>
          </b-tab>
          <b-tab>
            <template v-slot:title>
              <span class="">Realizado ({{ totalRealized }})</span>
            </template>
            <list-realized @loadRealizedList="loadRealizedList($event)" :filters="filter"/>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </b-modal>
</template>
<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import infiniteScroll from 'vue-infinite-scroll'
import ListWaiting from './listDetail/ListWaiting'
import ListRealized from './listDetail/ListRealized'

export default {
  components: {
    Loading,
    ListWaiting,
    ListRealized
  },
  directives: { infiniteScroll },
  data () {
    return {
      title: '',
      loading: true,
      filter: {},
      totalWaiting: 0,
      totalRealized: 0,
      modal: false
    }
  },
  methods: {
    loadWaitList (total) {
      this.totalWaiting = total
    },
    loadRealizedList (total) {
      this.totalRealized = total
    },
    loadItem (id) {
      if (id) {
        this.title = id === 'CheckedIn' ? 'CHECK-IN' : 'CHECK-OUT'
        this.filter = { ...this.filter, typeCheck: id }
      }
    },
    open (id = null, filter = {}) {
      this.modal = true
      this.loading = false
      if (id) {
        this.filter = filter
        this.loadItem(id)
      }
    },
    resetList () {
      this.totalWaiting = 0
      this.totalRealized = 0
    },
    close () {
      this.modal = false
      this.resetList()
    }
  },
  computed: {
  },
  watch: {
    modal () {
      if (!this.modal) {
        this.close()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "~bootstrap/scss/functions";
@import "src/design/variables";
.vld-overlay.is-full-page {
    z-index: 1051 !important;
}
.test-scroll {
  max-height: 300px;
  overflow-y: auto;
}
.custom-scroll{
  overflow-y: auto;
  max-height: 300px;
  padding-bottom: 0;
}
.fix-w {
  --width: 100px;
  --font-size: 13px;
  --icon-size: 16px;
  --btn-justify: space-evenly;
  --btn-padding: 0.20rem 0.08rem;
  @media (min-width: map-get($grid-breakpoints, "md")) {
    --width: 100px;
    --font-size: 13px;
    --icon-size: 16px;
    --btn-justify: space-around;
    --btn-padding: 0.20rem 0.35rem;
  }

  width: var(--width);

  button {
    font-size: var(--font-size);
    display: flex;
    align-items: center;
    justify-content: var(--btn-justify);
    padding: var(--btn-padding);

    i {
      font-size: var(--icon-size);
    }
  }
}

.row-item {
  --padding: 10px 5px;
  @media (min-width: map-get($grid-breakpoints, "md")) {
    --padding: 9px 5px;
  }
  background-color: #ffffff;
  border-radius: 5px;
  margin-bottom: 16px;
  padding: var(--padding);
  border: 1px solid rgba(233, 233, 233, 0.59);
  align-items: center;
  cursor: pointer;
}
.texts-box {
  .text-1 {
    font-size: 16px;
    color: #05162B;
  }

  .text-2 {
    font-size: 14px;
    color: #05162B87;
  }
}
</style>
